import {APP_COMMIT_DATE, APP_VERSION_EXTENDED} from "@buildwithflux/shared";
import {useEffect} from "react";

export default function SetVersion() {
    useEffect(() => {
        // eslint-disable-next-line no-console -- allow legacy console statements
        console.info(`FLUX: Current application version: ${APP_VERSION_EXTENDED} (${APP_COMMIT_DATE})`);
    }, []);

    return null;
}
